import { enGB } from '@clerk/localizations/en-GB';
import { itIT } from '@clerk/localizations/it-IT';
import { LocalizationResource } from '@clerk/types';

export const it: LocalizationResource = {
  ...itIT,
  signUp: {
    ...itIT.signUp,
    legalConsent: {
      ...itIT.signUp?.legalConsent,
      checkbox: {
        ...itIT.signUp?.legalConsent?.checkbox,
        label__termsOfServiceAndPrivacyPolicy:
          'Accetto i {{ termsOfServiceLink || link("Termini di Servizio") }} e la {{ privacyPolicyLink || link("Privacy policy") }}',
        label__onlyTermsOfService:
          'Accetto i {{ termsOfServiceLink || link("Termini di Servizio") }}',
        label__onlyPrivacyPolicy: 'Accetto la {{ privacyPolicyLink || link("Privacy policy") }}',
      },
    },
  },
};

export const en = enGB;
